export interface IPagingOptions {
  pageSize: number;
  page: number;
  sortBy: string;
  sortDirection: 'ASC' | 'DESC';
  query: string;
}

export class PagingOptions implements IPagingOptions {
  pageSize: number = 0;
  page: number = 0;
  sortBy: string = '';
  sortDirection: 'ASC' | 'DESC' = 'ASC';
  query: string = '';
  constructor(configOverride?: Partial<IPagingOptions>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IPagedResults<T> {
  options: IPagingOptions;
  results: T[];
  total: number;
}

export class PagedResults<T> implements IPagedResults<T> {
  options: IPagingOptions = new PagingOptions();
  results: T[] = [];
  total: number = 0;

  constructor(configOverride?: Partial<IPagedResults<T>>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
